"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTextRequestModel = void 0;
class TooltipTextRequestModel {
    constructor(visualIdPresModel, tupleId) {
        this.visualIdPresModel = visualIdPresModel;
        this.tupleId = tupleId;
    }
}
exports.TooltipTextRequestModel = TooltipTextRequestModel;
//# sourceMappingURL=AccessibilityModels.js.map